import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/user/user.service';

@Component({
  selector: 'app-call-invitation',
  templateUrl: './call-invitation.component.html',
  styleUrls: ['./call-invitation.component.css']
})
export class CallInvitationComponent implements OnInit {

  token: string;

  constructor(private router: Router
    , private route: ActivatedRoute
    , private userService: UserService) { }

  ngOnInit(): void {
    this.route.params.subscribe(param => {
      if (param['token']) {
        this.token = param['token'];
        this.userService.getToken(this.token).subscribe((data: any) => {
          this.router.navigate(['clientvideo/show/' + data.token]);
        });
      }
    });
  }

}
